const it = {
  langName: "Italiano",
  locale: "it_IT",
  meta: {
    home: ["Fondazione MADE — Diritti, salute e solidarietà", "MADE ONLUS sostiene le persone in condizioni di vulnerabilità con assistenza socio-sanitaria, beneficenza e formazione, in Repubblica Dominicana e in Italia."],
    about: ["Chi siamo — Fondazione MADE", "Storia, missione e valori della Fundación MADE: costruiamo i diritti fondamentali delle persone mettendo a disposizione le nostre competenze."],
    activities: ["Le attività — Fondazione MADE", "Assistenza socio-sanitaria, beneficenza, educazione e formazione, collaborazione con professionisti sanitari e sostegno a strutture sociali."],
    projects: ["Progetti — Fondazione MADE", "I progetti documentati di MADE: La Romana in Repubblica Dominicana e Villa Bevilacqua Relais a Rapagnano, nelle Marche."],
    laRomana: ["Progetto La Romana, Repubblica Dominicana — MADE", "Il progetto socio-sanitario di MADE a La Romana: un ospedale per i meno abbienti e, nell'attesa, una clinica mobile con specialisti."],
    villa: ["Villa Bevilacqua Relais, Rapagnano (FM) — MADE", "Il progetto di Villa Bevilacqua Relais nelle Marche: planimetrie, visualizzazioni 3D e caratteristiche documentate della struttura."],
    team: ["Il team — Fondazione MADE", "Il Presidente, il Direttore Sanitario e il personale medico della Fundación MADE."],
    gallery: ["Galleria fotografica — Fondazione MADE", "Fotografie originali delle persone, delle attività sanitarie, dei collaboratori e dei progetti di MADE."],
    donate: ["Dona ora — Sostieni MADE ONLUS", "Sostieni MADE con un bonifico, una donazione continuativa tramite modulo SDD o destinando il tuo 5×1000."],
    contact: ["Contatti — Fondazione MADE", "Scrivi a MADE ONLUS: indirizzo, fax, email e modulo di contatto."],
    privacy: ["Informativa privacy — MADE", "Informativa sul trattamento dei dati personali raccolti tramite il sito di MADE ONLUS."],
    cookies: ["Cookie policy — MADE", "Informazioni sui cookie e sulle tecnologie simili utilizzate dal sito di MADE ONLUS."],
    notFound: ["Pagina non trovata — MADE", "La pagina richiesta non esiste."],
  },
  nav: { home: "Home", about: "Chi siamo", activities: "Attività", projects: "Progetti", team: "Team", gallery: "Galleria", donate: "Donazioni", contact: "Contatti", donateNow: "Dona ora", menu: "Apri il menu", close: "Chiudi il menu", skip: "Vai al contenuto", language: "Lingua" },
  common: {
    discover: "Scopri di più",
    support: "Sostieni MADE",
    backToProjects: "Tutti i progetti",
    copy: "Copia",
    copied: "Copiato negli appunti",
    viewAll: "Vedi tutto",
    requestInfo: "Richiedi informazioni",
    source: "Fonte: documentazione MADE",
    statusNote: "I documenti della fondazione presentano il progetto e i suoi obiettivi; non riportano informazioni sul suo completamento o sulla sua operatività.",
    projectGallery: "Galleria del progetto",
    supportProject: "Sostieni questo progetto",
    supportProjectText: "Puoi indicare il progetto che desideri sostenere nella causale del bonifico.",
  },
  home: {
    eyebrow: "Fundación MADE · MADE ONLUS",
    titleLines: ["Costruiamo", "insieme un futuro", "migliore."],
    subtitle: "Ogni gesto di solidarietà può contribuire a tutelare i diritti fondamentali delle persone e a sostenere chi ha più bisogno.",
    ctaMission: "Scopri la nostra missione",
    ctaSupport: "Sostieni MADE",
    scroll: "Scorri",
    marquee: ["Assistenza socio-sanitaria", "Beneficenza", "Educazione", "Formazione", "Diritti fondamentali", "La Romana", "Rapagnano"],
    aboutEyebrow: "Chi siamo",
    aboutTitle: "Costruiamo i diritti fondamentali delle persone.",
    aboutText: "Sosteniamo, condividiamo, mettiamo a disposizione le nostre competenze a favore di quelle realtà di disagio che incontriamo e che ci incontrano.",
    activitiesEyebrow: "Le nostre attività",
    activitiesTitle: "Cura, sostegno e conoscenza per chi vive in condizioni di povertà.",
    projectsEyebrow: "Progetti in evidenza",
    projectsTitle: "Due territori, un solo impegno.",
    quote: "“Il tuo futuro è dato da cosa fai oggi, non domani.”",
    teamEyebrow: "Il team",
    teamTitle: "Persone che mettono la propria competenza al servizio degli altri.",
    galleryEyebrow: "Galleria",
    galleryTitle: "Volti, gesti, luoghi.",
    donateEyebrow: "Donazioni",
    donateTitle: "Il tuo sostegno rende possibile il nostro lavoro.",
    contactEyebrow: "Contatti",
    contactTitle: "Vuoi conoscerci, collaborare o chiedere informazioni?",
    contactText: "Scrivici: ti risponderemo il prima possibile.",
  },
  about: {
    eyebrow: "Chi siamo",
    titleLines: ["Chi è", "MADE"],
    intro: "Sosteniamo, condividiamo, mettiamo a disposizione le nostre competenze a favore di quelle realtà di disagio che incontriamo e che ci incontrano.",
    motto: "Costruiamo i diritti fondamentali delle persone.",
    storyTitle: "La nostra storia",
    story: "Il Presidente della Fundación MADE è l'Avvocato Marzia Bevilacqua. Da sempre sensibile alle problematiche sociali e spinta a proteggere i diritti degli ultimi, ha creato la Fundación MADE dopo un incontro con un gruppo di medici cubani a Santo Domingo.",
    missionTitle: "Missione",
    mission: "Garantire l'assistenza socio-sanitaria ai meno abbienti e sostenere, attraverso la beneficenza, l'insegnamento e la formazione, le persone che vivono in condizioni di povertà e di emarginazione.",
    visionTitle: "Visione",
    vision: "Un futuro in cui i diritti fondamentali di ogni persona siano tutelati, a partire da ciò che scegliamo di fare oggi.",
    valuesTitle: "I nostri valori",
    values: [
      ["Sostegno", "Siamo accanto alle realtà di disagio che incontriamo e che ci incontrano."],
      ["Condivisione", "Condividiamo risorse, tempo ed esperienze con chi ne ha più bisogno."],
      ["Competenza", "Mettiamo a disposizione competenze professionali, a partire da quelle mediche."],
      ["Dignità", "Tuteliamo i diritti fondamentali di ogni persona."],
    ],
    italyTitle: "MADE ONLUS in Italia",
    italyText: "In Italia la fondazione opera come MADE ONLUS, con sede in Corso Cavour 86 a Macerata, e raccoglie donazioni a sostegno delle proprie attività.",
  },
  activities: {
    eyebrow: "Attività",
    titleLines: ["Le", "attività"],
    intro: "La Fundación MADE basa le sue attività sull'assistenza socio-sanitaria, sulla beneficenza, sull'insegnamento e sulla formazione delle persone che vivono in condizioni di povertà e di emarginazione, contribuendo con donazioni per la costruzione di strutture atte al perseguimento dello scopo sociale.",
    items: [
      ["Assistenza socio-sanitaria", "Lo scopo primario della fondazione è garantire l'assistenza socio-sanitaria dei meno abbienti, anche attraverso una clinica mobile in grado di raggiungere le zone più inaccessibili della Repubblica Dominicana."],
      ["Beneficenza e sostegno alle persone vulnerabili", "Sosteniamo le persone che vivono in condizioni di povertà e di emarginazione, mettendo a disposizione risorse e competenze."],
      ["Educazione e formazione", "L'insegnamento e la formazione sono strumenti con cui offriamo nuove possibilità alle persone che incontriamo."],
      ["Collaborazione con professionisti sanitari", "Il personale medico e paramedico messo a disposizione da MADE è formato da un team di specialisti di origine cubana."],
      ["Strutture e iniziative sociali", "Contribuiamo con donazioni alla costruzione di strutture atte al perseguimento dello scopo sociale."],
    ],
    structures: ["Ospedali", "Pozzi", "Centri sociali", "Scuole"],
    structuresNote: "Esempi di strutture indicati nei documenti della fondazione.",
  },
  projects: {
    eyebrow: "Progetti",
    titleLines: ["Il", "progetto"],
    intro: "I progetti presentati nei documenti della fondazione: un intervento socio-sanitario in Repubblica Dominicana e una struttura nelle Marche, in Italia.",
    objectivesTitle: "Obiettivi documentati",
    laRomana: {
      name: "La Romana",
      place: "La Romana · Repubblica Dominicana",
      short: "La costruzione di un ospedale per garantire l'assistenza socio-sanitaria ai meno abbienti e, nell'attesa, una clinica mobile.",
      intro: "L'opera che la Fundación MADE intende realizzare, avendo come scopo primario quello di garantire l'assistenza socio-sanitaria dei meno abbienti, sarà la costruzione di un ospedale.",
      objectives: [
        "Costruzione di un ospedale per l'assistenza socio-sanitaria dei meno abbienti.",
        "Utilizzo, in attesa della struttura ospedaliera, di una clinica mobile in grado di raggiungere anche le zone più inaccessibili della Repubblica Dominicana.",
        "Messa a disposizione di personale medico e paramedico specializzato.",
      ],
      specialistsTitle: "Le specialità del team medico",
      specialistsText: "Ad oggi il personale medico e paramedico che la Fundación MADE mette a disposizione è formato da un team di specialisti, tutti di origine cubana, in:",
      specialists: ["Ortopedia", "Urologia", "Ginecologia", "Medicina generale", "Medicina interna", "Anestesiologia"],
    },
    villa: {
      name: "Villa Bevilacqua Relais",
      place: "Rapagnano (FM) · Marche · Italia",
      short: "Il progetto di una struttura su quattro livelli, con spazi per la cura della persona, ambulatori, camere, giardini pensili e un agrinido con animali.",
      intro: "Il progetto Villa Bevilacqua Relais, a Rapagnano in provincia di Fermo, è illustrato nella documentazione con una vista aerea dell'area, le planimetrie di ogni piano e le visualizzazioni 3D della struttura.",
      objectives: [
        "Una struttura che prevede un agrinido con animali, un'area di accoglienza per gli animali e un'area giochi per bambini.",
        "Al piano terra: spazi per il pranzo, la palestra, la fisioterapia, la cura della persona e ambulatori.",
        "Modulo da 20/22 posti con la struttura esistente, con camere al piano primo e al piano secondo.",
      ],
      floorsTitle: "Le planimetrie",
      floors: [
        ["Piano seminterrato", "Cucina (h 3,40 m), locali per il personale, lavanderia e centrale termica. Modulo da 20/22 posti con struttura esistente (camere al piano primo e secondo con requisiti di accreditamento minori).", "planSB"],
        ["Piano terra", "Pranzo 150 m², palestra 150 m², sala svago 85 m², fisioterapia 50 m², servizi 40 m², cura della persona 65 m², sala riunioni 150 m², uffici 50 m², reception 60 m², ambulatori e servizi 185 m².", "planGF"],
        ["Piano primo", "Otto camere con servizi, locale per il personale e giardino pensile. Area disponibile: 16 posti in 8 camere.", "planFF"],
        ["Piano secondo (sottotetto)", "Camere, sala personale, uscita su scala di sicurezza e giardino pensile. Area disponibile: 6 posti in 2 camere, oppure 4 posti in 1 camera con sala personale.", "planSF"],
      ],
      renderTitle: "Visualizzazioni 3D",
      renderText: "La struttura prevede un agrinido con animali, con un'area di accoglienza per gli animali e un'area giochi per i bambini.",
      aerialTitle: "L'area",
      aerialText: "Vista aerea del lotto di Villa Bevilacqua Relais a Rapagnano (FM).",
      elevationsTitle: "Prospetti",
    },
  },
  team: {
    eyebrow: "Team",
    titleLines: ["Il", "team"],
    intro: "Le persone documentate nella brochure della fondazione e il personale sanitario che MADE mette a disposizione.",
    presidentRole: "Il Presidente",
    presidentName: "Avv. Marzia Bevilacqua",
    presidentBio: "Da sempre sensibile alle problematiche sociali, spinta a proteggere i diritti degli ultimi, ha creato la Fundación MADE dopo un incontro con un gruppo di medici cubani a Santo Domingo.",
    directorRole: "Il Direttore Sanitario",
    directorName: "Dr. Dennis Livan Gonzalez Martinez",
    directorBio: [
      "Laureato in Medicina e Chirurgia all'Istituto Superiore di Scienze Mediche dell'Avana, Cuba, si specializza in Ortopedia e Traumatologia.",
      "Lavora per anni nei più celebri istituti pediatrici dell'Avana.",
      "Nel 2007, in missione umanitaria per conto del Governo cubano, viene inviato ad Haiti, dove si occupa delle vittime del terribile terremoto del 2010.",
      "Nel 2012 si trasferisce nella Repubblica Dominicana. Nel 2015 arriva in Italia.",
      "Intorno alla sua esperienza, alle sue capacità e alla sua umanità, la Fundación MADE ne costruisce e ne affida l'operatività.",
    ],
    staffTitle: "Personale medico e collaboratori",
    staffText: "Il personale medico e paramedico di MADE è formato da un team di specialisti di origine cubana. Le fotografie provengono dalla documentazione della fondazione.",
  },
  gallery: {
    eyebrow: "Galleria",
    titleLines: ["Galleria", "fotografica"],
    intro: "Fotografie originali tratte dalla documentazione della fondazione.",
    all: "Tutte",
    cats: { people: "Persone e comunità", health: "Attività sanitarie", volunteers: "Volontari e collaboratori", projects: "Progetti e strutture", architecture: "Documentazione architettonica" },
    close: "Chiudi",
    prev: "Immagine precedente",
    next: "Immagine successiva",
    open: "Ingrandisci immagine",
    captions: {
      handsWater: "Mani e acqua — immagine di copertina della brochure MADE",
      smilingGirls: "Due bambine sorridenti",
      girlBlue: "Una bambina con la maglietta azzurra",
      baby: "Un bambino in braccio",
      twoChildren: "Due bambini",
      childCap: "Un bambino con il cappellino giallo in corsia",
      childBed: "Un piccolo paziente",
      drDennis: "Dr. Dennis Livan Gonzalez Martinez, Direttore Sanitario",
      doctors: "Medici in camice",
      staff: "Personale sanitario",
      teamShirts: "Il gruppo MADE con le magliette della fondazione",
      volunteerChild: "Un collaboratore con un bambino",
      volunteerElderly: "Una collaboratrice MADE con un anziano",
      selfie: "Una collaboratrice con alcuni bambini",
      kidsBanner: "Bambini davanti al logo MADE",
      drafting: "Il Progetto — La Romana, Repubblica Dominicana",
      aerial: "Villa Bevilacqua Relais — vista aerea, Rapagnano (FM)",
      render3d: "Villa Bevilacqua Relais — visualizzazione 3D",
      agrinido: "Visualizzazione 3D: agrinido con animali e area giochi bambini",
      planSB: "Planimetria — piano seminterrato",
      planGF: "Planimetria — piano terra",
      planFF: "Planimetria — piano primo",
      planSF: "Planimetria — piano secondo (sottotetto)",
      elevations: "Prospetti della struttura",
    },
  },
  donate: {
    eyebrow: "Donazioni",
    titleLines: ["Dona ora", "a MADE Italia"],
    intro: "Aiutaci a sostenere la ONLUS MADE nelle sue attività.",
    bankTitle: "Versamenti su conto corrente",
    ibanLabel: "IBAN",
    bankLabel: "Presso",
    holderLabel: "Intestato a",
    causalLabel: "Causale",
    causal: "Se vuoi che la tua offerta vada a sostenere un progetto specifico, puoi indicarlo nella causale.",
    sddTitle: "Donazione continuativa",
    sddText: "Le donazioni continuative effettuate tramite il modulo SDD (ex RID) avvengono come bonifico a scadenza regolare con addebito automatico. Sono molto importanti per noi: ci permettono di programmare al meglio le nostre attività e di pianificare le nostre iniziative e i nostri interventi sul medio-lungo periodo.",
    sddThanks: "Ti ringraziamo del tuo aiuto nel far conoscere questa modalità di sostegno alle persone vicine a te.",
    sddHow: "Richiedi il modulo SDD, compilalo e invialo via fax o via email.",
    fiveTitle: "5×1000",
    fiveText: "Se non hai ancora destinato il tuo 5×1000, ricorda il nostro codice fiscale:",
    cfLabel: "Codice fiscale",
    ctaInfo: "Richiedi informazioni",
    ctaSdd: "Richiedi il modulo SDD",
    noOnline: "Questo sito non raccoglie pagamenti online: le donazioni avvengono esclusivamente tramite bonifico bancario, modulo SDD o 5×1000.",
    copyIban: "Copia IBAN",
    copyCf: "Copia codice fiscale",
  },
  contact: {
    eyebrow: "Contatti",
    titleLines: ["Scrivici"],
    intro: "Per informazioni, collaborazioni o per richiedere il modulo di donazione continuativa.",
    detailsTitle: "Recapiti",
    addressLabel: "Indirizzo",
    faxLabel: "Fax",
    emailLabel: "Email",
    form: {
      title: "Modulo di contatto",
      name: "Nome e cognome",
      email: "Email",
      subject: "Oggetto",
      message: "Messaggio",
      consent: "Ho letto l'informativa privacy e acconsento al trattamento dei miei dati per ricevere una risposta.",
      privacyLink: "Leggi l'informativa privacy",
      submit: "Invia messaggio",
      sending: "Invio in corso…",
      success: "Grazie! Il tuo messaggio è stato inviato correttamente. Ti risponderemo il prima possibile.",
      error: "Si è verificato un errore durante l'invio. Riprova più tardi o scrivici via email.",
      required: "Campo obbligatorio",
      invalidEmail: "Inserisci un indirizzo email valido",
      consentRequired: "È necessario accettare l'informativa privacy",
      minMessage: "Il messaggio deve contenere almeno 10 caratteri",
      requiredNote: "Tutti i campi sono obbligatori.",
    },
  },
  footer: {
    tagline: "Costruiamo i diritti fondamentali delle persone.",
    navTitle: "Navigazione",
    contactTitle: "Contatti",
    donateTitle: "Sostienici",
    rights: "Tutti i diritti riservati.",
    privacy: "Privacy",
    cookies: "Cookie",
    cookieSettings: "Preferenze cookie",
    photos: "Fotografie e immagini: documentazione originale MADE.",
  },
  cookie: {
    text: "Usiamo solo l'archiviazione tecnica necessaria al funzionamento del sito. Con il tuo consenso, la piattaforma che ospita il sito può raccogliere statistiche d'uso.",
    accept: "Accetta",
    reject: "Solo necessari",
    more: "Cookie policy",
  },
  legal: {
    privacyTitle: "Informativa privacy",
    privacy: [
      ["Titolare del trattamento", "MADE ONLUS, Corso Cavour 86 – 62100 Macerata. Codice fiscale 93078840431. Email: madeonlus-italia@gmail.com."],
      ["Dati raccolti", "Tramite il modulo di contatto raccogliamo nome, indirizzo email, oggetto e testo del messaggio, oltre alla lingua del sito e alla data di invio."],
      ["Finalità e base giuridica", "I dati sono trattati esclusivamente per rispondere alla tua richiesta, sulla base del tuo consenso (art. 6, par. 1, lett. a del Regolamento UE 2016/679)."],
      ["Conservazione", "I dati sono conservati per il tempo necessario a gestire la richiesta e non sono ceduti a terzi per finalità commerciali."],
      ["I tuoi diritti", "Puoi chiedere in qualsiasi momento l'accesso, la rettifica, la cancellazione o la limitazione dei tuoi dati, revocare il consenso e proporre reclamo al Garante per la protezione dei dati personali, scrivendo all'indirizzo email del titolare."],
    ],
    cookiesTitle: "Cookie policy",
    cookies: [
      ["Archiviazione tecnica", "Il sito memorizza nel tuo browser la scelta relativa ai cookie. Questa informazione è necessaria al funzionamento del sito e non richiede consenso."],
      ["Statistiche della piattaforma", "La piattaforma che ospita il sito può utilizzare strumenti di misurazione dell'utilizzo. Questi strumenti vengono attivati solo se accetti tramite il banner; scegliendo «Solo necessari» la raccolta viene disattivata."],
      ["Gestione delle preferenze", "Puoi modificare la tua scelta in qualsiasi momento tramite il link «Preferenze cookie» nel footer."],
    ],
  },
  notFound: { title: "Pagina non trovata", text: "La pagina che cerchi non esiste o è stata spostata.", back: "Torna alla home" },
};

export default it;
